import { Box, Group, Progress, Stack, Text } from "@mantine/core";
import { get901Stats } from "@mcapps/shared/startupChecklists/templates/901-overlevering/901Stats";
import type { IOverleveringChecklistRow } from "@mcapps/shared/startupChecklists/templates/901-overlevering/901Schema";
import { STANDARD_COLORS } from "../../../../globalConstants";

const segments = [
  { key: "yes", label: "Ja", color: STANDARD_COLORS.green },
  { key: "no", label: "Nei", color: STANDARD_COLORS.red },
  { key: "notRelevant", label: "Ikke relevant", color: "#f8992e" },
  { key: "unclear", label: "Uavklart", color: "#4085b6" },
  { key: "unanswered", label: "Ubesvart", color: "var(--mantine-color-gray-3)" },
] as const;

export const Progress901 = ({ report }: { report: { rows: IOverleveringChecklistRow[] } }) => {
  const stats = get901Stats(report);
  return (
    <Stack gap={4} style={{ flex: "1 1 340px", maxWidth: 600, minWidth: 0 }}>
      <Group justify="space-between" gap="xs">
        <Text size="xs" fw={500}>
          {stats.completionPercent} % avklart
        </Text>
        <Text size="xs" c="dimmed">
          {stats.resolved} av {stats.total} spørsmål · {stats.processed} behandlet
        </Text>
      </Group>
      <Progress.Root h={16} radius={4} aria-label="Fremdrift for hele sjekklisten">
        {segments.map(({ key, label, color }) => (
          <Progress.Section
            key={key}
            value={stats.percentages[key]}
            color={color}
            aria-label={`${label}: ${stats.counts[key]}`}
          />
        ))}
      </Progress.Root>
      <Group gap="sm" wrap="wrap">
        {segments.map(({ key, label, color }) => (
          <Group key={key} gap={4} wrap="nowrap">
            <Box aria-hidden style={{ width: 7, height: 7, borderRadius: 2, background: color }} />
            <Text size="xs" c="dimmed">
              {stats.counts[key]} {label}
            </Text>
          </Group>
        ))}
      </Group>
    </Stack>
  );
};
